module.exports = __webpack_public_path__ + "static/amir-1b396cf87d3bc6d608131f3b0c6740cd.mp4";